import PageTransition from "@/components/site/PageTransition";
import PageHero from "@/components/site/PageHero";
import Contact from "@/components/site/Contact";
import { useStartInquiry } from "@/lib/useInquiry";

export default function ContactPage() {
    const start = useStartInquiry("contact_page");
    return (
        <PageTransition>
            <PageHero
                crumbs={[{ label: "Home", to: "/" }, { label: "Contact" }]}
                eyebrow="Contact · Let's Build"
                title="Let's make your brand {gold:unmistakable}."
                intro="Send a short brief or reach out directly. We'll help you find the right engagement, from a focused logo system to a full brand ecosystem."
                tone="warm"
            />
            <Contact onStartProject={start} />
        </PageTransition>
    );
}
